export default "__VITE_ASSET__DxYMXjHq__"